document.querySelectorAll('.pursuit_contblock__grayscale').forEach((i) => {
  if (i) {
    i.classList.remove('pursuit_contblock__grayscale--anim');
  }
});
document.querySelectorAll('.pursuit_contblock__enhancedgrayscale').forEach((i) => {
  if (i) {
    i.classList.remove('pursuit_contblock__enhancedgrayscale--anim');
  }
});

let obs_contblock__image = new IntersectionObserver((entries) => {
  entries.map((entry) => {
    if (entry.isIntersecting) {
      if (entry.target.classList.contains('pursuit_contblock__grayscale')) {
        entry.target.classList.add('pursuit_contblock__grayscale--anim');
      }
      if (entry.target.classList.contains('pursuit_contblock__enhancedgrayscale')) {
        entry.target.classList.add('pursuit_contblock__enhancedgrayscale--anim');
      }
    } else {
      if (entry.target.classList.contains('pursuit_contblock__grayscale')) {
        entry.target.classList.remove('pursuit_contblock__grayscale--anim');
      }
      if (entry.target.classList.contains('pursuit_contblock__enhancedgrayscale')) {
        entry.target.classList.remove('pursuit_contblock__enhancedgrayscale--anim');
      }
    }
  });
}, { root: null, threshold: 0.99 });

document.querySelectorAll('.pursuit_contblock__grayscale').forEach((i) => {
  if (i) {
    obs_contblock__image.observe(i);
  }
});
document.querySelectorAll('.pursuit_contblock__enhancedgrayscale').forEach((i) => {
  if (i) {
    obs_contblock__image.observe(i);
  }
});
